import { SavvyAnswerChoice } from 'frontend/types/nux';
import { postData } from 'frontend/utils/ajax';

export async function saveAnswer(
  segmentationQuestionSlug: string,
  segmentationAnswerSlug: SavvyAnswerChoice,
): Promise<void> {
  // Multiple answers question send in an Array of answers
  // single answer question send in a string
  const segmentationAnswerChoice: string = Array.isArray(segmentationAnswerSlug)
    ? segmentationAnswerSlug.join(',')
    : segmentationAnswerSlug;

  const segmentationAnswer = {
    segmentation_question_slug: segmentationQuestionSlug,
    segmentation_answer_slug: segmentationAnswerChoice.replaceAll
      ? segmentationAnswerChoice.replaceAll('_', '-')
      : // We added this to support a couple of old browsers, hopefully we can remove it in a couple of months.
        segmentationAnswerChoice.replace(new RegExp('_', 'g'), '-'),
  };

  await postData('/api/v4/segmentation/answer/', segmentationAnswer);
}
